import * as _2021 from './2021/shared-2021';
import * as _2025 from './2025/shared-2025';
import Calendar from './calendar';

function init() {
  Calendar.init();
  _2021.init();
  _2025.init();
}

export default { init };
